import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useLocation } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Header from '../Element/Header'
import axios from 'axios'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(25)
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    divider: {
        marginBottom: theme.spacing(10)
    },
    paragraf: {
        textAlign: "justify",
        lineHeight: 2
    }
}));

export default function SuccessBiodata() {
    const classes = useStyles();
    const location = useLocation();
    const [name, setName] = useState('')

    useEffect(async () => {
        const getUserPayment = await axios({
            method: 'post',
            data: { payment_id: location.state.getPayment },
            url: `${process.env.REACT_APP_API}/participant/payment/user/check`,
        })
        if (getUserPayment.data !== "") {
            setName(`${getUserPayment.data.participant.first_name} ${getUserPayment.data.participant.last_name}`)
        }
        localStorage.removeItem("biodata")
    })

    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <div className={classes.paper}>
                <Header />
                {/* <Avatar alt="Jababeka Logo" src="/logo512.png" variant="square" className={classes.large} />
                <Typography component="h1" variant="h5">
                    KAWASAN INDUSTRI JABABEKA
                </Typography>
                <Typography variant="subtitle1">
                    PROUDLY PRESENT
                </Typography>
                <Typography component="h1" variant="h6">
                    VIRTUAL JOB FAIR 2021
                </Typography> */}
                {/* <Divider variant="middle" className={classes.divider} /> */}
                <Grid container alignItems="justified">
                    <Grid item xs>
                        <Typography component="body1" alignItems="left" gutterBottom>
                            Hai, <b>{name}</b>
                        </Typography>
                    </Grid>
                    <Typography color="textSecondary" variant="body2" className={classes.paragraf} gutterBottom>
                        Terima kasih telah melakukan registrasi di acara JABABEKA VIRTUAL JOB FAIR & SCHOLARSHIP HUNT 2021. Pastikan untuk hadir tepat waktu di Zoom Meeting pada 6-8 Juli 2021 untuk mendapatkan :
                        <br />
                        1. Update dan akses apply ke lowongan kerja dari perusahaan ternama di Indonesia
                        <br />
                        2. Update dan akses apply kesempatan beasiswa dari universitas ternama di Indonesia
                        <br />
                        3. Interaksi langsung di acara Networking Lounge langsung bersama HRD Perusahaan
                        <br />
                        4. Hadiah dan Grandprize senilai total 10 juta rupiah
                        <br />
                        *link zoom akan kami kirimkan ke email maks 5 Juli 2021
                    </Typography>
                    <Typography color="textSecondary" variant="body2" className={classes.paragraf} style={{ color: 'red' }} gutterBottom>
                        Penting!! Pastikan nomor registrasi kamu aman dan rahasia karena merupakan password kamu untuk Log In ke halaman My Profile (akses edit CV dan untuk apply kerja + beasiswa)
                    </Typography>
                    <Typography color="textSecondary" variant="body2" className={classes.paragraf} gutterBottom>
                        Informasi dan update :
                        <br />
                        follow official instagram kami @jababekalearningcenter
                        <br />
                        Kendala & Pertanyaan :
                        <br />
                        Customer Service - 0811 8444 595 (Whatsapp Only)
                    </Typography>
                </Grid>
            </div>
        </Container>
    );
}